<template>
    <div class="masonry-wrapper">
        <masonry
            :cols="{default: 3, 1775: 2, 1280: 1}"
            :gutter="{default: '30px', 767: '16px'}"
            >
            <chart-panel
                v-for="(chart, index) in charts"
                :key="chart.id"
                :can-update="canUpdate"
                v-model="charts[index]"
            ></chart-panel>

            <add-chart v-if="canUpdate"></add-chart>
        </masonry>
    </div>
</template>

<script>
    import AddChart from "./chart/addChart"
    import { call, get } from 'vuex-pathify'
    import ChartPanel from "./chart/chartPanel"

    export default {
        components: {
            AddChart,
            ChartPanel,

            isLoggedIn() {
                return this.currentClient && this.currentClient.id ? true : false
            },
        },

        data() {
            return {
                canUpdate: false,
            }
        },

        computed: {
            charts: get('charts/charts'),
            currentClient: get('auth/client'),
        },

        watch: {
            async currentClient(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.canUpdate = await this.can({ability: 'update', model: 'clients', id: this.currentClient.id})

                    this.loadCharts()
                }
            }
        },

        async mounted() {
            if (this.currentClient.id) {
                this.canUpdate = await this.can({ability: 'update', model: 'clients', id: this.currentClient.id})

                await this.loadCharts()
            }
        },

        methods: {
            can: call('auth/can'),
            loadCharts: call('charts/loadCharts'),
        }
    }
</script>
